import cx from 'classnames'
import _ from 'lodash'
import styles from './RankingTable.css'
import { dollarFormat, numeralFormat } from '../../../../../../lib/renderUtil'
import { pullLeft, pullRight } from '../../../../../styles/shared.css'
import { HyperLink } from '../../../../Common/Form'
import CommonRankingTable from '../../../../Common/NewDashboard/Table/RankingTable/RankingTable'
import { getAvailableCountLink } from '../../Shared'

export const FIELD = {
  LISTING_ID: 'listingId',
  NAME: 'name',
  SOLD_AMOUNT: 'soldAmount',
  SOLD_QUANTITY: 'soldQuantity',
  AVAILABLE_QUANTITY: 'availableQuantity'
}

export const FIELD_MAP = {
  [FIELD.LISTING_ID]: '賣場編號',
  [FIELD.NAME]: '賣場名稱',
  [FIELD.SOLD_AMOUNT]: '訂購金額',
  [FIELD.SOLD_QUANTITY]: '訂購量',
  [FIELD.AVAILABLE_QUANTITY]: '可訂購量'
}

const getColumns = props => [
  {
    /** 賣場編號 賣場名稱 */
    id: 'listingAndName',
    accessor: rowData => _.pick(rowData, [FIELD.LISTING_ID, FIELD.NAME]),
    headerClassName: cx(pullLeft, styles.listingAndNameCol),
    className: cx(pullLeft, styles.listingAndNameCol),

    Header: () => `${FIELD_MAP[FIELD.LISTING_ID]}／${FIELD_MAP[FIELD.NAME]}`,
    Cell: row => {
      const {
        value: {
          listingId,
          name
        }
      } = row

      return (
        <p className={styles.listing}>
          {listingId}
          <br />
          {name}
        </p>

      )
    }
  },
  {
    /** 訂購金額 */
    id: FIELD.SOLD_AMOUNT,
    accessor: FIELD.SOLD_AMOUNT,
    width: 140,
    Header: FIELD_MAP[FIELD.SOLD_AMOUNT],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => dollarFormat(row.value)
  },
  {
    id: FIELD.SOLD_QUANTITY,
    accessor: FIELD.SOLD_QUANTITY,
    width: 140,
    Header: FIELD_MAP[FIELD.SOLD_QUANTITY],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.AVAILABLE_QUANTITY,
    accessor: FIELD.AVAILABLE_QUANTITY,
    width: 140,
    Header: FIELD_MAP[FIELD.AVAILABLE_QUANTITY],
    headerClassName: cx(pullRight, styles.col, styles.lastCol),
    className: cx(pullRight, styles.col, styles.lastCol),
    Cell: row => {
      const { sharedLink, sendTableLinkPageview } = props
      const { shipType, listingId } = _.get(row, 'original', {})
      const availableCountLink = getAvailableCountLink(sharedLink, shipType, listingId)
      return (
        <HyperLink
          data-role='bestseller-available-count'
          target='_blank'
          href={availableCountLink}
          onClick={() => sendTableLinkPageview(FIELD.AVAILABLE_QUANTITY)}
        >
          {numeralFormat(row.value, { allowZero: true })}
        </HyperLink>
      )
    }
  }
]

const RankingTable = props => {
  const {
    data,
    rankingColumnProps,
    noFoundDescription,
    showPagination,
    readmoreProps = {},
    paginationProps = {}
  } = props
  return (
    <CommonRankingTable
      sortable={false}
      resizable={false}
      showPagination={showPagination}
      data={data}
      columns={getColumns(props)}
      className={styles.resultTable}
      noDataText={noFoundDescription}
      rankingColumnProps={rankingColumnProps}
      readmoreProps={readmoreProps}
      paginationProps={paginationProps}
    />
  )
}

export default RankingTable
